import { render, staticRenderFns } from "./RectangleElementPublish.vue?vue&type=template&id=5d357fda&"
import script from "./RectangleElementPublish.vue?vue&type=script&lang=ts&"
export * from "./RectangleElementPublish.vue?vue&type=script&lang=ts&"
import style0 from "./RectangleElementPublish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports